import * as actionTypes from "./actionTypes";

export const interestedUsersStart = () => ({
  type: actionTypes.INTERESTED_USERS_START,
});

export const getInterestedUsers = (search, pageLimit) => ({
  type: actionTypes.GET_ALL_INTERESTED_USERS,
  search,
  pageLimit,
});

export const getInterestedUsersSuccess = (response) => ({
  type: actionTypes.GET_ALL_INTERESTED_USERS_SUCCESS,
  response,
});

export const interestedUsersFail = (error) => ({
  type: actionTypes.INTERESTED_USERS_FAIL,
  error,
});
